module.exports = __webpack_public_path__ + "img/about-bg.08ac54d5.png";